import { render, staticRenderFns } from "./MdNotesByAppt.vue?vue&type=template&id=953ca0e4&"
import script from "./MdNotesByAppt.vue?vue&type=script&lang=js&"
export * from "./MdNotesByAppt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports